// @ts-nocheck
export const facebookIcon = (width: string, height: string, color?: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="126.445 2.281 589 589"
  >
    <circle cx="420.945" cy="296.781" r="294.5" fill="#3c5a9a" />
    <path
      d="M516.704 92.677h-65.239c-38.715 0-81.777 16.283-81.777 72.402.189 19.554 0 38.281 0 59.357H324.9v71.271h46.174v205.177h84.847V294.353h56.002l5.067-70.117h-62.531s.14-31.191 0-40.249c0-22.177 23.076-20.907 24.464-20.907 10.981 0 32.332.032 37.813 0V92.677h-.032z"
      fill={color ?? '#fff'}
    />
  </svg>
);

// @ts-nocheck
export const newFacebookIcon = (width: string, height: string, color?: string) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" version="1.1" id="svg9" width={width} height={height} viewBox="0 0 666.66668 666.66717"><script xmlns=""/>
      <defs id="defs13">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath25">
          <path d="M 0,700 H 700 V 0 H 0 Z" id="path23"/>
        </clipPath>
      </defs>
      <g id="g17" transform="matrix(1.3333333,0,0,-1.3333333,-133.33333,799.99999)">
        <g id="g19">
          <g id="g21" clipPath="url(#clipPath25)">
            <g id="g27" transform="translate(600,350)">
              <path d="m 0,0 c 0,138.071 -111.929,250 -250,250 -138.071,0 -250,-111.929 -250,-250 0,-117.245 80.715,-215.622 189.606,-242.638 v 166.242 h -51.552 V 0 h 51.552 v 32.919 c 0,85.092 38.508,124.532 122.048,124.532 15.838,0 43.167,-3.105 54.347,-6.211 V 81.986 c -5.901,0.621 -16.149,0.932 -28.882,0.932 -40.993,0 -56.832,-15.528 -56.832,-55.9 V 0 h 81.659 l -14.028,-76.396 h -67.631 V -248.169 C -95.927,-233.218 0,-127.818 0,0" style={{fill:color?color:"#0866ff",fillOpacity:1,fillRule:'nonzero',stroke:'none'}} id="path29"/>
            </g>
            <g id="g31" transform="translate(447.9175,273.6036)">
              <path d="M 0,0 14.029,76.396 H -67.63 v 27.019 c 0,40.372 15.838,55.899 56.831,55.899 12.733,0 22.981,-0.31 28.882,-0.931 v 69.253 c -11.18,3.106 -38.509,6.212 -54.347,6.212 -83.539,0 -122.048,-39.441 -122.048,-124.533 V 76.396 h -51.552 V 0 h 51.552 v -166.242 c 19.343,-4.798 39.568,-7.362 60.394,-7.362 10.254,0 20.358,0.632 30.288,1.831 L -67.63,0 Z" style={{fill:color?color:"#ffffff", fillOpacity:1, fillRule: 'nonzero', stroke: 'none'}} id="path33"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
)

export const googleIcon = (width: string, height: string, color?) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 326667 333333"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    width={width}
    height={height}
  >
    <path
      d="M326667 170370c0-13704-1112-23704-3518-34074H166667v61851h91851c-1851 15371-11851 38519-34074 54074l-311 2071 49476 38329 3428 342c31481-29074 49630-71852 49630-122593z"
      fill={color? color :"#4285f4"}
    />
    <path
      d="M166667 333333c44999 0 82776-14815 110370-40370l-52593-40742c-14074 9815-32963 16667-57777 16667-44074 0-81481-29073-94816-69258l-1954 166-51447 39815-673 1870c27407 54444 83704 91852 148890 91852z"
      fill={color? color :"#34a853"}
    />
    <path
      d="M71851 199630c-3518-10370-5555-21482-5555-32963 0-11482 2036-22593 5370-32963l-93-2209-52091-40455-1704 811C6482 114444 1 139814 1 166666s6482 52221 17777 74814l54074-41851z"
      fill={color? color :"#fbbc04"}
    />
    <path
      d="M166667 64444c31296 0 52406 13519 64444 24816l47037-45926C249260 16482 211666 1 166667 1 101481 1 45185 37408 17777 91852l53889 41853c13520-40185 50927-69260 95001-69260z"
      fill={color? color :"#ea4335"}
    />
  </svg>
);

export const xIcon = (width: string, height: string, color="#000") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 462.799"
    width={width}
    height={height}
  >
    <path
      fillRule="nonzero"
      style={{fill: color}}
      d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"
    />
  </svg>
);

export const bbbLogo = (width: string, height: string, color?: string) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 67"
    fill={'none'}
    color={color ? color : 'gray'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.2686 41.6212H7.81529L6.89087 44.6629H13.6736L14.9693 48.8596H26.1201L27.4103 44.6629H34.193L33.2686 41.6212ZM11.9689 24.528C11.224 25.5549 10.8225 26.7916 10.8225 28.0602C10.8225 29.9864 11.748 31.8001 13.3078 32.9304L19.3986 37.356C19.7894 37.6394 20.0212 38.0941 20.0212 38.5768C20.0212 38.8948 19.9206 39.205 19.7338 39.4625L20.651 40.1256L23.8694 35.6784C24.6148 34.656 25.0169 33.4227 25.0172 32.1574C25.0174 31.8363 24.992 31.5157 24.9415 31.1988C24.6909 29.6235 23.8203 28.2122 22.5251 27.2814L16.4343 22.8558C16.1101 22.6223 15.8924 22.2684 15.8306 21.8737C15.8178 21.7939 15.8111 21.7132 15.8108 21.6323C15.8102 21.3162 15.9106 21.0081 16.0973 20.7529L15.1819 20.088L11.9689 24.528ZM15.6396 6.73745C14.5584 8.22026 13.9758 10.009 13.9763 11.8441C13.9765 12.3094 14.0133 12.7739 14.0863 13.2334C14.4465 15.519 15.7066 17.568 17.584 18.9204L25.2407 24.4649C26.2473 25.1906 26.9225 26.2897 27.1148 27.5156C27.154 27.7612 27.1739 28.0093 27.1742 28.258C27.1719 29.2428 26.8562 30.2016 26.2732 30.9951L27.012 31.5339L33.0452 23.1964C34.1256 21.7071 34.7077 19.9136 34.7077 18.0738C34.7077 15.2797 33.3652 12.6492 31.1026 11.0098L21.8583 4.29042C20.6647 3.42206 20.3964 1.7259 21.2637 0.531572L20.5248 0L15.6396 6.73745ZM0 51.4003H6.97376C8.69107 51.4003 10.0372 51.8724 10.9003 52.7301C11.5831 53.4008 11.9561 54.3268 11.9293 55.2835V55.3195C11.9293 57.0151 11.0283 57.9594 9.94707 58.563C11.6842 59.2297 12.7582 60.237 12.7582 62.2552V62.2984C12.7582 65.0446 10.5273 66.4177 7.13594 66.4177H0V51.4003ZM6.26557 57.4728C7.72519 57.4728 8.64782 57.0007 8.64782 55.8853V55.8421C8.64782 54.8546 7.87476 54.2978 6.48542 54.2978H3.21838V57.4728H6.26557ZM7.14495 63.5237C8.60457 63.5237 9.48756 63.0084 9.48756 61.902V61.8588C9.48756 60.8497 8.73612 60.237 7.04043 60.237H3.21838V63.54L7.14495 63.5237ZM14.2034 51.4003H21.1772C22.8945 51.4003 24.2406 51.8724 25.1037 52.7301C25.7849 53.4017 26.1565 54.3274 26.1291 55.2835V55.3195C26.1291 57.0151 25.2281 57.9594 24.1469 58.563C25.8858 59.2297 26.958 60.237 26.958 62.2552V62.2984C26.958 65.0446 24.7271 66.4177 21.3357 66.4177H14.2034V51.4003ZM20.469 57.4728C21.9286 57.4728 22.8512 57.0007 22.8512 55.8853V55.8421C22.8512 54.8546 22.0782 54.2978 20.6888 54.2978H17.4236V57.4728H20.469ZM21.3484 63.5237C22.808 63.5237 23.691 63.0084 23.691 61.902V61.8588C23.691 60.8497 22.9395 60.237 21.2456 60.237H17.4236V63.54L21.3484 63.5237ZM28.4086 51.4003H35.3824C37.0997 51.4003 38.4458 51.8724 39.3089 52.7301C39.9915 53.401 40.3645 54.3268 40.3379 55.2835V55.3195C40.3379 57.0151 39.4369 57.9594 38.3557 58.563C40.0946 59.2297 41.1668 60.237 41.1668 62.2552V62.2984C41.1668 65.0446 38.9341 66.4177 35.5445 66.4177H28.4086V51.4003ZM34.6742 57.4728C36.1338 57.4728 37.0564 57.0007 37.0564 55.8853V55.8421C37.0564 54.8546 36.2834 54.2978 34.894 54.2978H31.6324V57.4728H34.6742ZM35.5536 63.5237C37.0132 63.5237 37.8962 63.0084 37.8962 61.902V61.8588C37.8962 60.8497 37.1447 60.237 35.449 60.237H31.6288V63.54L35.5536 63.5237ZM41.8732 63.2805V63.2643C41.8732 63.2616 41.8732 63.2589 41.8732 63.2562C41.8732 61.5757 43.256 60.1929 44.9366 60.1929C46.6141 60.1929 47.9955 61.5706 48 63.248V63.2643V63.2724C48 64.9529 46.6171 66.3357 44.9366 66.3357C43.2591 66.3357 41.8777 64.9579 41.8732 63.2805ZM47.6396 63.2643V63.248C47.6351 61.7683 46.4164 60.5533 44.9366 60.5533C43.4537 60.5533 42.2336 61.7733 42.2336 63.2562V63.2643V63.2805C42.2381 64.7602 43.4568 65.9753 44.9366 65.9753C46.4195 65.9753 47.6396 64.7552 47.6396 63.2724C47.6396 63.2697 47.6396 63.267 47.6396 63.2643ZM43.6752 61.5488H45.1168C45.4867 61.5283 45.8497 61.6584 46.1223 61.9092C46.3043 62.0997 46.4018 62.3559 46.3926 62.6192V62.6354C46.4117 63.0893 46.1227 63.5028 45.6898 63.6409L46.4845 64.8067H45.6466L44.9528 63.758H44.387V64.8067H43.6662L43.6752 61.5488ZM45.1168 63.1381C45.4772 63.1381 45.6754 62.9435 45.6754 62.6732V62.657C45.6754 62.3453 45.4556 62.1831 45.1006 62.1831H44.3978V63.1381H45.1168Z"
      fill={color ? color : '#015A75'}
    />
  </svg>
);
export const angiLogo = (width: string, height: string, color?: string) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 29"
    fill={'none'}
    color={color ? color : 'gray'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9324 0H9.40154L7.51215 11.794C7.47292 11.8005 7.43369 11.8005 7.38793 11.8071C3.21035 12.3628 -0.0388747 15.88 0.000351432 19.8157C0.0134268 21.4632 0.575668 22.7446 1.58247 23.7972C2.46506 24.732 3.69414 25.2616 4.98206 25.2681C5.47893 25.2681 5.96925 25.1897 6.43343 25.0262C8.68893 24.2483 9.43422 22.3589 9.78726 20.6264V20.6329C9.88532 18.7043 8.85891 16.7953 6.89107 15.6643L6.26999 19.5934C6.06732 20.7114 5.81235 21.3782 5.25011 21.5678C4.91669 21.6855 4.50481 21.5613 4.23023 21.2736C3.87066 20.901 3.66145 20.4826 3.65492 19.7765C3.6353 17.8086 5.18473 16.2657 6.89107 15.6643C7.44023 15.4682 8.02209 15.3701 8.60394 15.3766C9.25117 15.3832 9.8984 15.4943 10.5064 15.7035C12.8142 16.2461 14.2067 18.6912 14.5532 21.339L14.7559 22.823H18.5935L14.9324 0ZM10.9967 12.0489L12.1016 3.6088H12.2324L13.4614 13.0296C12.6835 12.6046 11.8532 12.2712 10.9967 12.0489ZM47.7973 6.3677V22.8296H43.9728V6.3677H47.7973ZM36.6244 28.5304C41.6519 28.5304 42.0442 25.6669 42.0442 21.6201L42.0769 6.3677H40.0894C39.3768 6.3677 38.5008 6.90379 38.4419 7.59025L38.3962 8.1198L38.2131 7.6164C37.8404 6.62267 36.9121 6.09312 35.5261 6.09312C34.1401 6.09312 33.1006 6.62921 32.4599 7.68831C31.8389 8.71473 31.7081 10.0419 31.7081 10.9768V17.3772C31.7081 18.9658 31.9369 20.1361 32.4142 20.9533C32.996 21.947 33.9309 22.4308 35.2842 22.4308C36.5656 22.4308 37.5332 21.8882 38.0104 20.901L38.2392 20.4303V22.7838C38.2392 24.3986 38.1412 25.5362 36.8533 25.5362C36.5591 25.5362 35.598 25.4381 35.598 24.1502V24.1044H31.7343V24.1829C31.7343 25.4316 32.0742 26.4384 32.7411 27.1771C33.5713 28.0728 34.8723 28.5304 36.6244 28.5304ZM38.1804 16.7168C38.1804 18.2859 37.9581 19.1358 36.7944 19.1358C35.6896 19.1358 35.5392 18.0832 35.5392 17.0503V11.3167C35.5392 10.0223 36.0034 9.39465 36.9579 9.39465C38.03 9.39465 38.1804 10.4472 38.1804 11.4802V16.7168ZM48 2.74583C48 3.91607 47.0717 4.82481 45.8883 4.82481C44.7508 4.83788 43.8224 3.92261 43.8093 2.78505C43.8093 2.77198 43.8093 2.7589 43.8093 2.73929C43.8093 1.55597 44.7246 0.627617 45.8883 0.627617C47.052 0.634154 48 1.58212 48 2.74583ZM23.6471 11.6828V22.8296H19.7834L19.7507 6.3677H21.895C22.6338 6.3677 23.4837 6.89071 23.5752 7.66216L23.6145 8.0152L23.7975 7.70792C24.4186 6.64228 25.4319 6.09966 26.7983 6.09966C28.995 6.09966 30.1129 7.51833 30.1129 10.3165V22.8296H26.2884V11.1794C26.2884 9.99611 25.8765 9.39465 25.0658 9.39465C24.0198 9.39465 23.6471 9.99611 23.6471 11.6828Z"
      fill={color ? color : '#FF6153'}
    />
    <path
      d="M9.7875 20.6394C9.98363 19.8157 10.4282 16.6449 10.5066 15.71C9.8921 15.5008 9.25141 15.3897 8.60418 15.3831C8.02232 15.3766 7.44047 15.4746 6.88477 15.6708C8.85261 16.7953 9.88556 18.7043 9.7875 20.6394Z"
      fill={color ? color : 'gray'}
    />
  </svg>
);

export const zillowLogo = (width: string, height: string, color?: string) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 53"
    fill={'none'}
    color={color ? color : 'gray'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.4558 14.2188C32.697 14.1652 32.8042 14.2456 32.9506 14.4064C33.7814 15.33 36.4368 18.5729 37.1583 19.4573C37.2923 19.6181 37.1995 19.7933 37.0923 19.8861C31.7322 24.067 25.768 29.9899 22.4447 34.2245C22.3788 34.3193 22.4324 34.3193 22.486 34.3049C28.2749 31.8124 41.8752 27.8315 48.0002 26.7203V18.9625L24.028 0L0.0146484 18.9481V27.4295C7.4508 23.0094 24.6568 16.1608 32.4558 14.2188Z"
      fill={color ? color : '#006AFF'}
    />
    <path
      d="M12.9447 46.8085C12.7447 46.9157 12.5819 46.8889 12.4211 46.7281L7.94537 41.3948C7.8258 41.2463 7.81136 41.1659 7.97217 40.9391C11.4315 35.8738 18.4925 27.98 22.995 24.6443C23.0754 24.5907 23.0486 24.5227 22.9537 24.5639C18.2636 26.0916 4.93132 31.8269 0 34.6142V52.7294H47.9876V35.2842C41.4483 36.3954 21.857 42.2256 12.9447 46.8085Z"
      fill={color ? color : '#006AFF'}
    />
  </svg>
);

export const homeAdvisorLogo = (
  width: string,
  height: string,
  color?: string,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 39"
    fill={'none'}
    color={color ? color : 'gray'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.2115 17.7206L18.3081 4.85156L8.33301 14.7997V25.4324C8.33301 26.9017 9.53967 28.108 11.0117 28.108L22.8349 28.1237L32.322 38.5258L32.3617 28.156L36.9314 28.1237C38.4024 28.1237 39.6101 26.9184 39.6101 25.448V17.7206H31.2115Z"
      fill={color ? color : '#455A64'}
    />
    <path
      d="M31.9503 0H16.0497L0 15.6385H4.55896L18.311 1.92041L32.063 15.6385H48L31.9503 0Z"
      fill={color ? color : '#FB8C00'}
    />
  </svg>
);
export const houzzLogo = (width: string, height: string, color?: string) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill={'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" />
    <path
      d="M28.2527 38H38V21.5203L18.4839 15.9557V9H12V38H21.7688V28.8613H28.2527V38Z"
      fill={color ? color : '#4DBC15'}
    />
  </svg>
);
